import React from 'react';
function Command({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.333 4a2.667 2.667 0 00-2.666 2.667v10.666a2.667 2.667 0 102.666-2.666H6.667a2.667 2.667 0 102.666 2.666V6.667a2.667 2.667 0 10-2.666 2.666h10.666a2.667 2.667 0 100-5.333z"
      />
    </svg>
  );
}

export default Command;
